module.exports = __webpack_public_path__ + "img/kong-environments.5aa15629.svg";